'use client';

import Link from 'next/link';
import { FC, PropsWithChildren, useCallback } from 'react';
import { useOptionalSidebar } from '@spikemark/ui/components/design-system/sidebar';
export const EnsureSidebarLink: FC<PropsWithChildren<{
  href: string;
}>> = ({
  children,
  href
}) => {
  const sidebar = useOptionalSidebar();
  const handleClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0 || e.defaultPrevented) {
      return;
    }
    if (sidebar && !sidebar.isMobile && sidebar.state === 'collapsed') {
      sidebar.setOpen(true);
    }
  }, [sidebar]);
  return <Link href={href} onClick={handleClick} data-sentry-element="Link" data-sentry-component="EnsureSidebarLink" data-sentry-source-file="ensure-sidebar-link.tsx">
      {children}
    </Link>;
};